module.exports = __webpack_public_path__ + "img/658.c1e65e78.png";